"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _syncLog = require("@/api/syncLog");
var _SyncDetail = _interopRequireDefault(require("./components/SyncDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "SyncLog",
  components: {
    SyncDetail: _SyncDetail.default
  },
  data: function data() {
    return {
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 同步日志列表
      syncLogList: [],
      // 统计数据
      statistics: {},
      // 同步加载状态
      syncLoading: {
        business: false,
        store: false,
        full: false
      },
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        syncType: null,
        syncMethod: null,
        status: null,
        startTime: null,
        endTime: null
      }
    };
  },
  created: function created() {
    var _this = this;
    this.getList();
    this.getStatistics();
    // 设置定时刷新
    this.timer = setInterval(function () {
      _this.getStatistics();
    }, 30000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  watch: {
    dateRange: function dateRange(val) {
      if (val && val.length === 2) {
        this.queryParams.startTime = val[0];
        this.queryParams.endTime = val[1];
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
      }
    }
  },
  methods: {
    /** 查询同步日志列表 */getList: function getList() {
      var _this2 = this;
      this.loading = true;
      (0, _syncLog.getSyncLogList)(this.queryParams).then(function (response) {
        _this2.syncLogList = response.data.records;
        _this2.total = response.data.total;
        _this2.loading = false;
      });
    },
    /** 获取统计数据 */getStatistics: function getStatistics() {
      var _this3 = this;
      (0, _syncLog.getSyncStatistics)().then(function (response) {
        _this3.statistics = response.data;
      });
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      this.dateRange = [];
      this.$refs.queryForm.resetFields();
      this.handleQuery();
    },
    /** 触发同步 */handleSync: function handleSync(syncType) {
      var _this4 = this;
      var typeMap = {
        'business': '商户',
        'store': '门店',
        'full': '全量'
      };
      this.$modal.confirm("\u786E\u8BA4\u8981\u8FDB\u884C".concat(typeMap[syncType], "\u6570\u636E\u540C\u6B65\u5417\uFF1F")).then(function () {
        _this4.syncLoading[syncType] = true;
        var syncPromise = syncType === 'full' ? (0, _syncLog.fullSync)() : (0, _syncLog.triggerSync)(syncType);
        return syncPromise;
      }).then(function () {
        _this4.$modal.msgSuccess("同步任务已启动");
        _this4.getList();
        _this4.getStatistics();
      }).finally(function () {
        _this4.syncLoading[syncType] = false;
      });
    },
    /** 查看详情 */handleDetail: function handleDetail(row) {
      this.$refs.syncDetail.show(row.id);
    },
    /** 重试同步 */handleRetry: function handleRetry(row) {
      var _this5 = this;
      this.$modal.confirm("确认要重试该同步任务吗？").then(function () {
        return (0, _syncLog.triggerSync)(row.syncType);
      }).then(function () {
        _this5.$modal.msgSuccess("重试任务已启动");
        _this5.getList();
      });
    },
    /** 获取同步类型标签类型 */getSyncTypeTagType: function getSyncTypeTagType(syncType) {
      var typeMap = {
        'business': 'primary',
        'store': 'success',
        'full': 'warning'
      };
      return typeMap[syncType] || 'info';
    },
    /** 获取同步类型文本 */getSyncTypeText: function getSyncTypeText(syncType) {
      var typeMap = {
        'business': '商户同步',
        'store': '门店同步',
        'full': '全量同步'
      };
      return typeMap[syncType] || '未知';
    },
    /** 获取状态标签类型 */getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        'running': 'warning',
        'success': 'success',
        'failed': 'danger'
      };
      return statusMap[status] || 'info';
    },
    /** 获取状态文本 */getStatusText: function getStatusText(status) {
      var statusMap = {
        'running': '同步中',
        'success': '成功',
        'failed': '失败'
      };
      return statusMap[status] || '未知';
    },
    /** 获取成功率 */getSuccessRate: function getSuccessRate(row) {
      if (row.totalCount === 0) return 0;
      return Math.round(row.successCount / row.totalCount * 100);
    },
    /** 获取成功率样式类 */getSuccessRateClass: function getSuccessRateClass(row) {
      var rate = this.getSuccessRate(row);
      if (rate === 100) return 'success-rate';
      if (rate >= 80) return 'warning-rate';
      return 'danger-rate';
    }
  }
};